<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "เพิ่ม" : "แก้ไข" }} ข้อมูล</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <vs-input label="ค่ากำจัดขยะฯ" type="number" v-model="BA14" class="mt-5 w-full" name="bill" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('bill')">กรุณากรอกค่ากำจัดขยะฯ</span>
      </div>
      <div class="p-6 pt-0">
        <vs-input label="ค่าขยะ" type="number" v-model="BA15" class="mt-5 w-full" name="bill" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('bill')">กรุณากรอกค่าขยะ</span>
      </div>

      <div class="p-6 pt-0">
        <vs-input label="รหัสผ่าน" type="password" v-model="password" class="mt-5 w-full" name="password" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('password')">กรุณากรอกรหัสผ่าน</span>
        <span class="text-danger text-sm" v-show="checkPassword && password !== ''">รหัสผ่านไม่ถูกต้อง</span>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="confirmEdit" :disabled="!isFormValid">ตกลง</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">ยกเลิก</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moduleBookList from "@/store/booklist/moduleBookList.js";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/dist/locale";

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    },
    org: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    Datepicker,
    VuePerfectScrollbar,
  },
  data() {
    return {
      dataId: null,
      BA14: '',
      BA15: '',
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
      password: '',
      orgPassword: '',
      checkPassword: false
    }
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return;
      if(Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset()
      }else {
        let data = JSON.parse(JSON.stringify(this.data));
        this.orgPassword = this.org.password;
        this.dataId = data._id;
        this.BA14 = data.BA14;
        this.BA15 = data.BA15;
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    formatThaiDateToIsoDate(date){
      const year = date.split('/')[2]

    },
    initValues() {
      if(this.data.id) return;
        this.dataId = null;
        this.BA14 = "";
        this.BA15 = ""
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          if (result) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: 'คำเตือน',
              text: 'คุณต้องการเแก้ไขข้อมูลใช่หรือไม่',
              acceptText: 'ต้องการ',
              cancelText: 'ยกเลิก',
              accept: this.confirmEdit
            });
          }
      })
    },
    async confirmEdit() {
      let obj = {};
      const data = JSON.parse(JSON.stringify(this.data));
      const user = JSON.parse(sessionStorage.getItem('vuex'));
      const staffId = user.owner.user.user._id;
      if(this.password !== this.orgPassword) {
        this.checkPassword = true;
        return;
      }
      this.checkPassword = false;
      obj = {
        B01: data.B01,
        member_id: data.member_id,
        staff_id: staffId,
        BA15: this.BA15,
        BA14: this.BA14
      };
      await this.$store.dispatch("bookLists/updateItemForMeter", obj).then((res) => {
        if (res.status === 201) {
          this.password = '';
          this.$emit('closeSidebar');
        }
      });
    }
  },
  async created() {
    if (!moduleBookList.isRegistered) {
      this.$store.registerModule('bookLists', moduleBookList);
      moduleBookList.isRegistered = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
